import React, { type CSSProperties, type FunctionComponent, useCallback } from 'react';

import BaseResizeHandle from './base-resize-handle';

interface OverlayResizeHandleProps {
  id: string;
  style?: CSSProperties;
  onDragging?: (isDragging: boolean) => void;
  currentWidth: number;
  minWidth: number;
  maxWidth: number;
  onResize: (newWidth: number) => void;
}

const OverlayResizeHandle: FunctionComponent<OverlayResizeHandleProps> = ({
  id,
  style,
  onDragging,
  currentWidth,
  minWidth,
  maxWidth,
  onResize,
}) => {
  const handleResize = useCallback(
    (delta: number, startSize: number) => {
      const newWidth = Math.max(minWidth, Math.min(maxWidth, startSize + delta));
      onResize(newWidth);
    },
    [minWidth, maxWidth, onResize]
  );

  return (
    <BaseResizeHandle
      id={id}
      style={style}
      onDragging={onDragging}
      minSize={minWidth}
      maxSize={maxWidth}
      currentSize={currentWidth}
      onPointerResize={handleResize}
      onKeyboardResize={handleResize}
      keyboardStep={10}
    />
  );
};

export default OverlayResizeHandle;
